import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import sharedNode from '@/views/examine/claimRecordManage/components/sharedNode.vue';
import currentNode from '@/views/examine/claimRecordManage/components/currentNode.vue';
import procedure from '@/components/examine/procedure.vue';
import schedule from '@/components/examine/schedule.vue';
import { auditScheduleResource } from '@/views/examine/typeManage/request';
import { auditSchedule, auditDetail, auditOperate, policyDetail } from './request';
import singleLineMultilineModel from '@/views/questionnaire/customerManage/questionnaireList/components/singleLineMultilineModel.vue'; //单行文本and多行文本
import emailSendModel from '@/views/components/emailSend/emailSendModel.vue';
import { groupInsuranceDetail } from './request';
import summaryInfo from './summaryInfo.vue';
export default {
  components: {
    procedure,
    schedule,
    singleLineMultilineModel,
    emailSendModel,
    sharedNode,
    currentNode,
    summaryInfo
  },
  data() {
    return {
      scheduleList: [],
      procedureList: [],
      step: 0,
      scheduleInfo: {},
      detailsObj: null,
      formData: {},
      editableArea: [],
      echoNodeIsEdit: null,
      //回显区可编辑状态true可编辑false不可编辑
      editSharedNodeInfo: [],
      //回显区可以编辑的数据
      showSendEmail: false,
      notifyData: null,
      crrentNodeIsEdit: true,
      policyInfo: {},
      loading: false,
      showVisible: false,
      form: {
        dataId: 0,
        policyNo: undefined
      },
      rules: {
        dataId: [{
          required: true,
          message: '请选择数据存放方式',
          trigger: 'change'
        }],
        policyNo: [{
          required: true,
          message: '请选择保单号',
          trigger: 'change'
        }]
      },
      currentButtonItem: null,
      headerInfo: {},
      source: ''
    };
  },
  created() {
    this.getInfoFun();
    // policyDetail({policyId: this.$route.params.policyId}).then(res => {
    //   this.policyInfo = res.policyInfo;
    //   this.policyInfo.customerName = res.baseInfo.customerName;
    // });
    this.$store.dispatch('quiretionnaire/getResource');
    groupInsuranceDetail({
      auditFlowDetailId: this.$route.params.id
    }).then(res => {
      this.source = res.source;
      this.headerInfo = res.baseInfo;
    });
  },
  methods: {
    async getInfoFun() {
      const res = await auditScheduleResource({
        auditFlowTypeId: this.$route.params.auditFlowTypeId
      });
      if (res.length != 0) {
        this.procedureList = res;
        this.procedureList.unshift({
          iconName: 'container',
          id: -1,
          name: this.$t('报案理赔')
        });
      }
      this.getscheduleFun();
    },
    async getscheduleFun() {
      this.scheduleList = await auditSchedule({
        auditFlowDetailId: this.$route.params.id
      });
      this.scheduleInfo = this.scheduleList[this.scheduleList.length - 1];
      if (!this.scheduleInfo.currentScheduleOperator && !this.scheduleInfo.operationAt && this.scheduleInfo.step == '0') {
        this.scheduleInfo = this.scheduleList[this.scheduleList.length - 2];
      }
      this.stepFun();
      this.detailFun();
    },
    stepFun() {
      this.step = this.procedureList.findIndex(val => {
        return val.id == this.scheduleInfo.auditFlowScheduleId;
      });
      if (this.step == -1) {
        this.step = 0;
      }
    },
    async detailFun() {
      this.detailsObj = null;
      const res = await auditDetail({
        auditScheduleId: this.scheduleInfo.id
      });
      console.log(res, 'dkd');
      /**
       * 操作按钮进入$route.params.type == 2可以编辑
       * 查看按钮进入$route.params.type == 1不可以编辑
       */
      if (this.$route.params.type == 2) {
        this.$route.meta.title = this.$t('理赔审核');
        this.crrentNodeIsEdit = true;
        this.$nextTick(function () {
          // 判断回显节点是否可编辑
          if (res.renderState === 'EDIT') {
            this.echoNodeIsEdit = true;
            res.sharedNodeInfo.forEach(item => {
              if (item.isEdit === true) {
                item.echoNodeIsEdit = true;
              } else {
                item.echoNodeIsEdit = false;
              }
            });
          } else {
            this.echoNodeIsEdit = false;
          }
        });
        this.$forceUpdate();
      } else {
        this.$route.meta.title = this.$t('理赔详情');
        this.crrentNodeIsEdit = false;
        this.echoNodeIsEdit = false;
      }
      this.detailsObj = res;
    },
    goInfoFun(val) {
      this.scheduleInfo = val;
      this.stepFun();
      this.detailFun();
    },
    // 按钮点击
    onSubmit(buttonItem) {
      this.currentButtonItem = buttonItem;
      if (this.detailsObj.sharedNodeInfo.length > 0) {
        this.$refs.sharedNode.onSubmit();
      }
      if (this.detailsObj.editableAreaInfo.length > 0) {
        this.$refs.currentArea.onSubmit();
      }
      let status = true;
      if (this.detailsObj.sharedNodeInfo.length > 0 && status) {
        status = this.$refs.sharedNode.vidateStatus;
      }
      if (this.detailsObj.editableAreaInfo.length > 0 && status) {
        status = this.$refs.currentArea.vidateStatus;
      }
      if (status) {
        // 所有校验成功
        // 处理回显节点isEdit:true的情况
        if (this.detailsObj.sharedNodeInfo.length > 0) {
          this.editSharedNodeInfo = JSON.parse(JSON.stringify(this.detailsObj.sharedNodeInfo));
          this.editSharedNodeInfo.forEach((item, index) => {
            if (item.isEdit === false) {
              this.editSharedNodeInfo.splice(index, 1);
            }
          });
        }
        if (buttonItem.goBack === 'END_NODE_SUCCESS' && this.source === 'groupInsurance') {
          //如果是结束审核流的按钮 弹出选择数据存入方式
          this.showVisible = true;
          return;
        }
        this.resultSaveFunc();
      } else {
        this.$message.error(this.$t('请填写完整'));
        return;
      }
    },
    resultSaveFunc() {
      var _this$$refs$currentAr, _this$$refs$sharedNod, _this$currentButtonIt;
      let editSubmitArea = this.$refs.currentArea && (_this$$refs$currentAr = this.$refs.currentArea.submitData) !== null && _this$$refs$currentAr !== void 0 && _this$$refs$currentAr.length ? this.$refs.currentArea.submitData : '';
      let shareSubmitArea = this.$refs.sharedNode && (_this$$refs$sharedNod = this.$refs.sharedNode.submitData) !== null && _this$$refs$sharedNod !== void 0 && _this$$refs$sharedNod.length ? this.$refs.sharedNode.submitData : '';
      //如果按钮有发送邮件的功能 打开发送邮件的弹窗
      console.log(this.currentButtonItem, '-------buttonItem-------');
      if (((_this$currentButtonIt = this.currentButtonItem) === null || _this$currentButtonIt === void 0 || (_this$currentButtonIt = _this$currentButtonIt.notify) === null || _this$currentButtonIt === void 0 ? void 0 : _this$currentButtonIt.length) > 0) {
        this.notifyData = this.currentButtonItem;
        this.showSendEmail = true;
        this.$nextTick(() => {});
      } else {
        let params = {
          auditScheduleId: this.scheduleInfo.id,
          editableArea: JSON.stringify(editSubmitArea),
          sharedNodeInfo: shareSubmitArea ? JSON.stringify(shareSubmitArea) : '',
          actionButton: this.currentButtonItem
        };
        if (this.currentButtonItem.goBack === 'END_NODE_SUCCESS' && this.form.dataId === 1) {
          params.dataId = this.form.policyNo;
        }
        this.requestSave(params);
      }
    },
    okSubmit() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          this.showVisible = false;
          this.resultSaveFunc();
        }
      });
    },
    close() {
      this.currentButtonItem = null;
      this.showVisible = false;
    },
    // 提交接口
    requestSave(params, type) {
      this.loading = true;
      auditOperate(params).then(res => {
        this.loading = false;
        if (type === 'PREVIEW_FILE') {
          var _res$previewFiles;
          this.previewFileList = [];
          (_res$previewFiles = res.previewFiles) === null || _res$previewFiles === void 0 || _res$previewFiles.forEach((item, index) => {
            this.previewFileList.push({
              name: item.fileName,
              url: item.filePath,
              uid: index + 1,
              status: 'done'
            });
          });
        } else {
          this.$message.success('提交成功');
          this.$router.push('/groupOrderManage/groupOrderExamine');
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    // 发送邮件回调
    closeModel(notifyData) {
      var _this$$refs$currentAr2, _this$$refs$sharedNod2;
      let editSubmitArea = this.$refs.currentArea && (_this$$refs$currentAr2 = this.$refs.currentArea.submitData) !== null && _this$$refs$currentAr2 !== void 0 && _this$$refs$currentAr2.length ? this.$refs.currentArea.submitData : '';
      let shareSubmitArea = this.$refs.sharedNode && (_this$$refs$sharedNod2 = this.$refs.sharedNode.submitData) !== null && _this$$refs$sharedNod2 !== void 0 && _this$$refs$sharedNod2.length ? this.$refs.sharedNode.submitData : '';
      let params = {
        auditScheduleId: this.scheduleInfo.id,
        editableArea: JSON.stringify(editSubmitArea),
        sharedNodeInfo: JSON.stringify(shareSubmitArea),
        actionButton: notifyData
      };
      this.requestSave(params);
    }
  }
};